import {default as Text} from './TextField'

export const Field = {Text}
